import moment from 'moment'
import _ from 'common-tools/LodashHelper'
import queryString from 'query-string'

export const FormatHelper = {
  Date: (dateText, DateFormat = {}) => {
    if (!dateText) {
      return ''
    }
    const parsedDate = moment(dateText)
    if (parsedDate.isValid()) {
      return parsedDate.format(DateFormat.OnlyDate || 'MM?DD?YYYY')
    } else {
      return '??'
    }
  },
  InlineAuditLabelFields: (fields, d, DateFormat = {}) => {
    fields.push({ icon: 'plus-circle', value: moment(d.CreatedByDate).fromNow(), helptext: `Created by ${d.CreatedByName} on ${moment(d.CreatedByDate).format(DateFormat.DateAndTime || 'MM?DD?YYYY h?mm a')}` })
    fields.push({ icon: 'edit', value: moment(d.UpdatedByDate).fromNow(), helptext: `Updated by ${d.UpdatedByName} on ${moment(d.UpdatedByDate).format(DateFormat.DateAndTime || 'MM?DD?YYYY h?mm a')}` })
    return fields
  },
  DateTime: (dateText, DateFormat = {}) => {
    if (!dateText) {
      return ''
    }
    const parsedDate = moment(dateText)
    if (parsedDate.isValid()) {
      return parsedDate.format(DateFormat.DateAndTime || 'MM?DD?YYYY h?mm a')
    } else {
      return '??'
    }
  },
  Time: (dateText, DateFormat = {}) => {
    if (!dateText) {
      return ''
    }
    const parsedDate = moment(dateText)
    if (parsedDate.isValid()) {
      return parsedDate.format(DateFormat.OnlyTime || 'h?mm a')
    } else {
      return '??'
    }
  },
  DateLongText: (dateText) => {
    if (!dateText) {
      return ''
    }
    const parsedDate = moment(dateText)
    if (parsedDate.isValid()) {
      return parsedDate.format('dddd, MMMM Do YYYY')
    } else {
      return '??'
    }
  },
  FromNow: (dateText) => {
    if (!dateText) {
      return ''
    }
    const parsedDate = moment(dateText)
    if (parsedDate.isValid()) {
      return parsedDate.fromNow()
    } else {
      return '??'
    }
  },
  FromOptions: (value, options, valueProp = 'Value', textProp = 'Text') => {
    if (_.isArray(options) && options.length > 0) {
      if (!value) {
        return value
      } else {
        let valueHasMatch = _.find(options, (o) => { return o[valueProp] === value })

        if (!valueHasMatch) {
          return value
        } else {
          return valueHasMatch[textProp]
        }
      }
    } else {
      return value
    }
  },
  FormatFromTimeStringToDate: (value) => {
    let newDate = moment(`2000-01-01T${value}`)
    return newDate
  },
  FormatFromDateToTimeString: (value) => {
    let newDate = moment(value)
    return newDate.format('HH:mm')
  },
  QueryString: (rawString) => {
    return queryString.parse(rawString)
  },
  BuildTimeOptions (dayStart, dayStop, timeFormat = 'h:mm a', stepMinutes = 15) {
    let timeStart = dayStart || '00:00'
    let timeStop = dayStop || '23:45'

    let currentDate = moment('2000-01-01').format('YYYY-MM-DD')
    let listStartTime = moment(`${currentDate}T${timeStart}`)
    let listEndTime = moment(`${currentDate}T${timeStop}`)

    if (timeStop === '00:00') {
      listEndTime = listEndTime.add(1, 'd')
    }

    let ret = []

    while (listStartTime.isSameOrBefore(listEndTime) === true) {
      ret.push({
        Text: listStartTime.format(timeFormat),
        Value: listStartTime.format('HH:mm')
      })
      listStartTime.add(stepMinutes, 'm')
    }

    return ret
  },
  BuildYearOptions (start = 1944, stop) {
    let lstop = stop || moment().add(1, 'year').year()
    let ret = []
    let loop = start
    for (loop = lstop; loop >= start; loop--) {
      ret.push({
        Text: loop,
        Value: loop
      })
    }
    return ret
  },
  RoundTime: (time, minutesToRound = 15) => {
    let [hours, minutes] = time.split(':')
    hours = parseInt(hours)
    minutes = parseInt(minutes)

    // Convert hours and minutes to time in minutes
    time = (hours * 60) + minutes

    let rounded = Math.round(time / minutesToRound) * minutesToRound
    let rHr = '' + Math.floor(rounded / 60)
    let rMin = '' + rounded % 60

    return rHr.padStart(2, '0') + ':' + rMin.padStart(2, '0')
  },
  TruncateText: (text, length) => {
    var val = text || ''
    return (val.length > length) ? val.substr(0, length - 1) + '...' : val
  },
  ToBase64: (file) => new Promise((resolve, reject) => {
    var reader = new FileReader() // eslint-disable-line
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  }),
  ToText: (file) => new Promise((resolve, reject) => {
    var reader = new FileReader() // eslint-disable-line
    reader.readAsText(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  }),
  OasisDate: (date) => {
    const dateText = date || '99990000'
    return `${dateText.substring(4, 6)}/${dateText.substring(6, 8)}/${dateText.substring(0, 4)}`
  },
  BuildDateTimeFromParts: (datepart, timepart) => {
    let ret = moment(datepart)

    let timeParts = _.split(timepart, ':')
    let hourPart = parseInt(timeParts[0])
    let minutePart = parseInt(timeParts[1])

    if (_.isNaN(hourPart) === false) {
      ret.set('hour', hourPart)
    }

    if (_.isNaN(minutePart) === false) {
      ret.set('minute', minutePart)
    }

    ret.set('second', 0)

    return ret

    // return moment(`${moment(datepart).format('YYYY-MM-DD')}T${timepart}`)
  }
}
